import { render, staticRenderFns } from "./FriendshipAdmin.vue?vue&type=template&id=575e1a7e"
import script from "./FriendshipAdmin.vue?vue&type=script&lang=ts"
export * from "./FriendshipAdmin.vue?vue&type=script&lang=ts"
import style0 from "./FriendshipAdmin.vue?vue&type=style&index=0&id=575e1a7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports